const initialState = {
  topUpData: {
    type: null,
    trigger: null,
    amount: null
  },
  singleTopUpData: {
    amount: 0
  }
}

const ActivationTopUpModule = {
  namespaced: true,
  state: initialState,
  getters: {
    topUpCore (state) {
      if (state.topUpData.type === 'byLimit') {
        return {
          autoTopup: {
            amount: state.topUpData.amount || 0,
            trigger: state.topUpData.trigger || 0,
            type: 'ACCOUNT_BALANCE'
          }
        }
      }
      if (state.topUpData.type === 'monthly') {
        return {
          autoTopup: {
            amount: state.topUpData.amount || 0,
            trigger: state.topUpData.trigger || 0,
            type: 'DAY_OF_MONTH'
          }
        }
      }
      return null
    },
    topUp: state => state.topUpData,
    singleTopUpAmount: state => state.singleTopUpData.amount,
    topUpWithoutPayment: state => {
      return (state.topUpData === undefined || state.topUpData.type === null) && state.singleTopUpData.amount === 0
    },
    topUpAutoByLimit: state => {
      return state.topUpData?.type === 'byLimit'
    },
    topUpAutoMonthly: state => {
      return state.topUpData?.type === 'monthly'
    }
  },
  actions: {
  },
  mutations: {
    setWithoutTopUp (state) {
      state.topUpData.type = 'withoutAuto'
    },
    storeTopUpData (state, topUpData) {
      state.topUpData = topUpData
    },
    storeSingleTopUpAmount (state, amount) {
      state.singleTopUpData.amount = amount
    }
  }
}

export default ActivationTopUpModule
